<template>
  <div class="review-item">
    <ym-avatar class="user-avatar"
            :avatar="user.avatar"
            :name="user.name"
            size="extra-small"
            lazy
    />
    <div class="content-info">
      <div class="content-header">
        <span class="user-name">{{ user.name }}</span>
        <div class="rate-content">
          <ym-icon class="icon-rate"
                    name="rate-fill"
                    v-for="item in rateValue"
                    :key="item"
          />
        </div>
      </div>
      <div class="content"
           :class="{ 'ym-four-line-ellipsis': limitContentLine }"
      >{{ content }}</div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'ReviewItem',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
      rate: {
        type: Number,
      },
      content: {
        type: String,
        required: true,
      },
      limitContentLine: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      rateValue() {
        const { rate } = this;
        const result = Math.ceil(rate);
        if (result > 5) return 5;
        if (result < 0) return 0;
        return result;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .review-item {
    display: flex;
    padding: @size-base 0;
    margin: 0 @size-base;
    background-color: @color-white;
    &:not(:last-child) {
      border-bottom: @border-base;
    }
  }

  .user-avatar {
    flex-shrink: 0;
    margin-right: @size-small;
  }

  .content-info {
    flex: 1;
  }

  .content-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: @size-extra-small;
  }

  .user-name {
    color: @color-text-light;
    font-size: @font-size-small;
    line-height: 1;
  }

  .rate-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .icon-rate {
      margin-right: 8px;
    }
  }

  .icon-rate {
    font-size: 16px;
    color: @color-highlight;
  }

  .content {
    line-height: 1.5;
    word-break: break-word;
  }
</style>
